export const colors = {
  midnightBlue: '#252a33',
  navyBlue: '#003261',
  mermaidBlue: '#003f78',
  twilightBlue: '#004a8d',
  cobaltBlue: '#0053a1',

  azureBlue: '#006dcf',
  cowbellBlue: '#2282e3',
  cornflowerBlue: '#78b0f0',
  arcticBlue: '#b3d5fc',
  frostBlue: '#e7effe',

  corianderBlue: '#465266',
  skyBlue: '#4eabd6',

  midnightGray: '#252a33',
  charcoal: '#383f4d',
  corianderGray: '#515766',
  lapisGray: '#656e80',
  gunmetalBlue: '#7a869a',

  slateBlue: '#95a2b7',
  stormyBlue: '#b1c2de',
  harborBlue: '#cad5e8',
  ice: '#e7effe',
  frostedSteel: '#f8f8ff',

  mammaryRed: '#a60c18',
  blush: '#cf6679',

  terraCotta: '#e46d18',
  deepSkyBlue: '#0c66a6',
  copper: '#d7844b',

  forestGreen: '#1ab556',
  mintGreen: '#66cf87',

  white: '#ffffff',
  black: '#000000',
  jetBlack: '#121212',

  emailBodyBackground: '#f1f5f9',

  darkSlateBlue: '#26262e',
  darkNavyBlue: '#1f1f29',

  softWhite: 'rgba(255, 255, 255, 0.2)',
  softBlack: 'rgba(0, 0, 0, 0.2)',
} as const;
